<template>
  <div class="content">
    <chiqim-form :datas="dataall"></chiqim-form>
    <kontragent :datas="dataall"></kontragent>
    <sklad :datas="dataall"></sklad>
    <b-modal id="modal-close" centered>
      <h4>
        {{$t('Sizda saqlanmagan malumotlar mavjud. Saqlansinmi?')}}
      </h4>

      <template #modal-footer="{ ok, cancel, hide }">
        <button type="button" class="btn btn-success" style="margin-bottom: 16px;"
          @click="$root.$refs.rasxod.Savedokument('home')">{{$t('Да')}}</button>
        <button type="button" class="btn btn-danger" @click='Home()'>{{$t('Нет')}}</button>
        <button type="button" class="btn btn-primary" @click="cancel()">{{$t('Отмена')}}</button>
      </template>
    </b-modal>
  </div>
</template>
<script>
  import { ChiqimForm, Kontragent, Sklad } from "@/pages";
  export default {
    components: { ChiqimForm, Kontragent, Sklad },
    data() {
      return {
        watch: false,
        update_password: "",
        dataall: {}
      };
    },
    watch: {
      dataall: {
        deep: true,
        handler(val, oldVal) {
          this.$store.state.saved += 1;
        }
      }
    },
    beforeRouteLeave(to, from, next) {
      if (this.$store.state.saved < 2) {
        this.$store.state.saved = null;
        next();
      } else {
        this.$bvModal.show("modal-close");
      }
    },
    mounted() {
      this.Data();
      this.Sklad();
    },
    methods: {
      Data() {
        let self = this;
        axios
          .get("api/v1/rasxod/id/" + self.$route.params.id)
          .then(function (response) {
            self.dataall = response.data;
            setTimeout(() => {
              self.watch = true;
            }, 100);
          });
      },
      Home() {
        this.$store.state.saved = null;
        this.$bvModal.hide('modal-close');
        this.$router.push({ name: "Чиқим" });
      },
      Sklad() {
        let self = this;
        axios
          .get("api/v1/sklads/id/" + localStorage.getItem("sklad_id"))
          .then(function (response) {
            self.update_password = response.data.update_password;
          });
      }
    }
  };
</script>